import { ReactNode } from 'react';

import { IconInfo } from '../Icons/IconInfo';

type ErrorProps = {
    children: ReactNode;
};

export const Error = ({ children }: ErrorProps) => {
    return (
        <div className="flex items-start space-x-1 text-left">
            <div className="w-4 fw-svg mt-0 text-danger-300">
                <IconInfo />
            </div>
            <div className="text-sm flex-1">{children}</div>
        </div>
    );
};
